/**
 * Convierte cualquier objeto de error en un mensaje claro, específico e instructivo
 * para el personal en campo (inspectores / técnicos / gestores).
 */
export const formatInspectorError = (err) => {
    if (!err) return 'Ocurrió un error inesperado. Intenta de nuevo.';
    
    const msg = typeof err === 'string' ? err : err.message || '';
    const errName = typeof err === 'object' && err?.name ? err.name : '';
    const lowerMsg = msg.toLowerCase();

    // 1. Detección de sesión expirada / autenticación
    if (
        lowerMsg.includes('401') ||
        lowerMsg.includes('not authenticated') ||
        lowerMsg.includes('unauthorized') ||
        lowerMsg.includes('token') ||
        lowerMsg.includes('sesión') ||
        lowerMsg.includes('inicia sesión')
    ) {
        return '🔐 Sesión no válida o expirada: Por favor recarga la aplicación o vuelve a iniciar sesión con tu cuenta.';
    }

    // 2. Detección de error de GPS / Ubicación
    const isGpsError = 
        lowerMsg.includes('geolocation') ||
        lowerMsg.includes('geolocalizacion') ||
        lowerMsg.includes('ubicacion') ||
        lowerMsg.includes('gps') ||
        lowerMsg.includes('position') ||
        lowerMsg.includes('denied');

    if (isGpsError) {
        return '📍 Error de GPS / Ubicación: No se pudieron obtener tus coordenadas GPS actuales. Asegúrate de tener activada la Ubicación en la barra de tu teléfono con alta precisión y de dar permiso a la aplicación.';
    }

    // 3. Timeout por velocidad de subida lenta en red celular (subiendo fotos)
    if (
        errName === 'AbortError' ||
        lowerMsg.includes('timeout') ||
        lowerMsg.includes('tardó más de') ||
        lowerMsg.includes('sin respuesta del servidor')
    ) {
        return '⏳ Tiempo de espera agotado: La red celular en este punto tiene una velocidad de subida muy lenta para transferir la foto al servidor. Intenta acercarte a una zona con mejor señal 4G/5G.';
    }

    // 4. Detección de error de conexión / señal celular
    // Solo si el navegador realmente está sin conexión física
    const isDeviceOffline = typeof navigator !== 'undefined' && !navigator.onLine;
    if (isDeviceOffline) {
        return '📶 Modo Fuera de Línea: Tu teléfono no tiene conexión a internet en este momento. Tu foto y avance están guardados de forma segura en el dispositivo. En cuanto recuperes conexión presiona Enviar.';
    }

    // 5. Error de socket o fallo de red mientras el navegador reporta estar online
    const isNetworkSocketError = 
        lowerMsg.includes('failed to fetch') ||
        lowerMsg.includes('networkerror') ||
        lowerMsg.includes('load failed');

    if (isNetworkSocketError) {
        return '📶 Falla momentánea de comunicación con el servidor (microcorte de datos móviles o latencia alta). Tus puntos NO se han perdido; intenta presionar nuevamente el botón para enviar.';
    }

    // 6. Errores devueltos por el servidor (400, 422, 404, 500)
    if (lowerMsg.includes('422') || lowerMsg.includes('unprocessable') || lowerMsg.includes('formato')) {
        return `⚠️ Error en formato de datos: ${msg}. Verifica que la foto de evidencia sea legible.`;
    }

    if (lowerMsg.includes('404') || lowerMsg.includes('finalizada')) {
        return '⚠️ La jornada no fue encontrada en el servidor o ya fue finalizada.';
    }

    if (lowerMsg.includes('500')) {
        return `⚠️ Error interno del servidor al procesar el punto (${msg}). Tus datos no se perdieron en el teléfono; intenta nuevamente en unos momentos.`;
    }

    // 7. Error general
    return msg || 'Ocurrió un error al procesar la solicitud. Intenta de nuevo.';
};

export default formatInspectorError;
